import {Client} from "@stomp/stompjs";
import {useGetSelfEmployeeQuery} from "../../store/api/employeeApi";
import {useEffect, useState} from "react";
import {useDispatch} from "../../store/store";
import {printApi, useGetPrintsNotificationQuery} from "../../store/api/printApi";
import {PrintNotificationDTO} from "../../types/print/PrintNotificationDTO";
import useSound from "use-sound";
import {INFO} from "../../types/utils/Constants";

type UseWebSocketType = PrintNotificationDTO[] | undefined | null

const client = new Client({
    brokerURL: process.env.REACT_APP_WEBSOCKET_BASE_URL,
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
});

const UseWebSocket = (): UseWebSocketType => {

    const {data: employee} = useGetSelfEmployeeQuery()
    const {data} = useGetPrintsNotificationQuery()
    const [oldNotification, setOldNotification] = useState<PrintNotificationDTO[] | null>()
    const [notification, setNotification] = useState<PrintNotificationDTO[] | null>()
    const dispatch = useDispatch()
    const [play] = useSound(process.env.REACT_APP_NOTIFICATION_SOUND_URL ?? '/sounds/notification.mp3')

    useEffect(() => {
        if (oldNotification?.at(0) && oldNotification?.filter(item => item.type !== INFO)?.map(item => item.count)?.reduce((acc, it) => acc + it, 0) !==
            data?.data?.filter(item => item.type !== INFO)?.map(item => item.count)?.reduce((acc, it) => acc + it, 0)) {
            play()
            dispatch(printApi.util.invalidateTags(["prints"]))
        }

        setOldNotification(notification)
        setNotification(data?.data)
    }, [data])

    useEffect(() => {
        if (client && !client.connected) {
            client.onConnect = () => {
                if (employee?.data?.account) {
                    client.subscribe(`/prints/${employee?.data?.account?.id}`, (msg) => {
                        if (msg.body) {
                            const data = JSON.parse(msg.body)
                            dispatch(printApi.util.updateQueryData("getPrintsNotification", undefined, (draftNotifications) => {
                                draftNotifications.data = data ?? []
                            }))
                        }
                    })
                }
            }

            // IN CASE, CLIENT IS NOT ACTIVE, ACTIVATE IT
            if (!client.active) client.activate()

            // TURNING OFF WEBSOCKET BEFORE CLOSING COMPONENT
            return () => {
                client.deactivate().then()
            }
        }
    }, [dispatch, employee])

    return notification
}

export default UseWebSocket